var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.errors.length > 0)?_c('div',[_c('ul',{staticClass:"errors-list"},_vm._l((_vm.errors),function(error){return _c('li',{key:error.code,staticClass:"item-error"},[_vm._v(" "+_vm._s(error.description)+" ")])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }